import { OdataManager } from '@/api/odata/odata-manager';
import { DrawingPackage_TitleObject } from '@/api/model/interfaces';

export default class DrawingPackageTitleObjectOdata extends OdataManager<DrawingPackage_TitleObject> {}
